import { Observable } from 'rxjs';
import { NestApiProvider } from './../../nest-api';
import { Injectable } from "@angular/core";
import { RequestDownloadExcelDto, RequestSendEmailExcelDto, ResponseSendEmailExcelDto } from '../dto/loan-request-report.dto';

@Injectable()
export class LoanRequestReportApi{
    private service: string ='';
    private model: string ='sf6s/loanRequestReport'
    
    constructor(
        private nestApiProvider: NestApiProvider
    ){}

    downloadExcel(data:RequestDownloadExcelDto){
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: RequestDownloadExcelDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams,body)
    }

    reportSendEmailExcel(data:RequestSendEmailExcelDto): Observable<ResponseSendEmailExcelDto>{
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestSendEmailExcelDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailExcelDto>(method, url, params, urlParams,body)
    }

    type(): Observable<any>{
        const method: string = 'GET';
        const func: string = 'type';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<any>(method, url, params, urlParams,body)
    }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/loan-request-report.api.ts